import { Component, OnInit } from '@angular/core';
import { ParlacenTV } from 'src/app/models/parlacen-tv.model';
import { ParlacenTvService } from 'src/app/services/parlacen-tv.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PARLACEN_TV_STATUS } from 'src/app/enums/enums';
import { error } from 'protractor';

@Component({
  selector: 'app-parlacen-tv',
  templateUrl: './parlacen-tv.component.html',
  styleUrls: ['./parlacen-tv.component.css']
})
export class ParlacenTvComponent implements OnInit {
  public videos:        ParlacenTV[] = [];
  public status:        string;
  public identity:      string;
  public token:         string;
  public myVideo:       ParlacenTV;
  public loading:       boolean = false;
  public isSubmitting:  boolean = false;
  public isDeleting:    boolean = false;
  public page:          number = 1;
  public pageSize:      number = 10;
  
  
  constructor(
    private _parlacenTvServices:  ParlacenTvService,
    private _userService:         UserService,
    private _router:              Router,
    protected _sanitizer:         DomSanitizer,
  ) {
    this.cleanVideo();
  }

  ngOnInit(): void {
   // $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token    = this._userService.getToken();
    if (!this.identity || !this.token) {
      this._router.navigate(['/iniciar-sesion']);
    } else {
      this.listarVideos();
    }
  } 

  agregarVideo(): void {
    if (
      !this.myVideo.title ||
      !this.myVideo.description ||
      !this.myVideo.video ||
      !this.myVideo.creationDate
    ) {
      return alert('Por favor, rellene los campos obligatorios');
    }
    this.isSubmitting = true;
    this._parlacenTvServices.addVideo(this.myVideo).subscribe(
      res => {
        if (!res.document) {
          this.status = 'error';
        } else {
          this.status = 'ok';
          this.cleanVideo();
        }
        this.isSubmitting = false;
      },
      err => this.onError(err)
    );
  } 
   
  eliminarVideo():void {
    this._parlacenTvServices.deleteVideo(this.myVideo.id).subscribe(
      res => {
        alert(res.message);
        this.isDeleting = false;
        //this.listarDocumentos();
        this.cleanVideo();
      },
      err => this.onError(err)
    );

  } 
    listarVideos(): void {
      this.loading = true;
      this._parlacenTvServices.getVideosForAdmin().subscribe(
        res => {
          if (!res.parlamentTv) {
            this.status = 'error';
          } else {
            if (res.parlamentTv.length === 0) {
              alert('No hay videos para mostrar');
            } else {
              this.videos = res.parlamentTv;
             
            }
            this.status = 'ok';
          }
          this.loading = false;
        },
        err => this.onError(err)
      )
    
  }

  sortArray(array: any[]): any[] {
    return array.sort((a, b) => (b.year.toString()).localeCompare(a.year.toString()));
  }

  setVideo(video: ParlacenTV): void {
    this.myVideo = video;
  }

  cleanVideo() {
    this.myVideo = new ParlacenTV('', '', '', '', '', '', PARLACEN_TV_STATUS.ACTIVE);
  }

  onError(error: any): void {
    let errorMessage = error;
   
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
    this.isSubmitting = false;
    this.isDeleting = false;
  }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustUrl(oldURL);
  }
  cleanURLResource(oldURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }
}
